import {StoreType} from '..';
import {
	IOrganizationAttendee,
	IOrganizationAttendeesListResponse,
	IOrganizationAttendeesStatistics,
} from '../../utils/types';

export const getAttendeeLoaderSelector = (state: StoreType): boolean => state.organizationAttendeesStore.isLoading;

export const getAttendeesListSelector = (state: StoreType): IOrganizationAttendeesListResponse =>
	state.organizationAttendeesStore.attendeesList;

export const getAttendeeSelector = (state: StoreType): IOrganizationAttendee | null =>
	state.organizationAttendeesStore.attendee;

export const getAttendeeStatisticsSelector = (state: StoreType): IOrganizationAttendeesStatistics | null =>
	state.organizationAttendeesStore.attendeesStatistics;
